import React from 'react';
import { motion } from "motion/react";
import { useAuth } from '@/hooks/useAuth';
import { ConfirmationCodeForm } from './ConfirmationCodeForm';

export const ConfirmationCodeHero: React.FC = () => {
  const { pendingSignupData } = useAuth();
  
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <motion.main 
      className="pt-16 pb-8"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="min-h-[calc(100vh-6rem)] flex items-center justify-center px-8">
        <div className="w-full max-w-md">
          
          {/* Header Section */}
          <motion.div 
            className="text-center mb-8"
            variants={itemVariants}
          >
            <motion.div 
              className="mb-4"
              variants={itemVariants}
            >
              <span className="inline-block px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-sm font-medium border border-gray-200/10 text-white">
                Verify Your Account
              </span>
            </motion.div>
            <motion.h1 
              className="text-3xl lg:text-4xl font-serif font-medium text-white mb-3 tracking-tight"
              variants={itemVariants}
            >
              Enter Confirmation Code
            </motion.h1>
            <motion.p 
              className="text-gray-400 leading-relaxed"
              variants={itemVariants}
            >
              We've sent a verification code to <span className="text-white font-medium">{pendingSignupData?.email}</span>
            </motion.p>
          </motion.div>

          {/* Confirmation Code Form */}
          <motion.div variants={itemVariants}>
            <ConfirmationCodeForm />
          </motion.div>
        </div>
      </div>
    </motion.main>
  );
};
